import type { AIModelProviderResponse, AIModelVersionResponse } from '@/types/response'

export type EnabledAIModel = AIModelVersionResponse & {
  provider_display_name: string
  provider_label: string
}

export function filterEnabledModels(models: AIModelProviderResponse[]): EnabledAIModel[] {
  return models.flatMap((model) =>
    model.model_version
      .filter((version) => version.checked)
      .map((version) => ({
        ...version,
        provider_display_name: model.provider_display_name,
        provider_label: model.label,
      })),
  )
}
